export default __webpack_public_path__ + "static/media/330_business04-es-web.080a779a.png";